import { LO_STO } from '../lib'
import loSto from '../config/loSto'
import { BASE_URL } from '../config'

const END_POINTS = {
  FETCH_USER_FEATURE_FLAGS: '/preferences/feature-flags'
}

const fetchFeatureFlags = () => {
  const orgId = loSto.get(LO_STO.ORGANIZATION_ID)
  const userId = loSto.get(LO_STO.USER_ID)
  const url = BASE_URL + END_POINTS.FETCH_USER_FEATURE_FLAGS + `/${userId}`

  return fetch(url, {
    method: 'GET',
    headers: {
      authorization: loSto.get('okta-token-storage')?.idToken?.value,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': 'no-cors',
      'Content-Type': 'application/json',
      'X-Suki-Organization-Id': orgId,
      'X-Suki-User-Id': userId
    }
  }).then((response) => response.json())
}

export { fetchFeatureFlags }
